import { EventEmitter } from 'events';

const eventEmitter = new EventEmitter();

eventEmitter.setMaxListeners(1);

export default eventEmitter;